import React from "react";
import { Container, Box } from "@mui/material";
import FindList from "../components/FindList";
import PlacesCategoryList from "../components/PlacesCategoryList";
import { useSearchParams } from "react-router-dom";
import FixedBottomNavigation from "../components/FixedBottomNavigation";
import HeaderBar from "../components/HeaderBar"; // ✅ 헤더 컴포넌트 추가

const Find = () => {
  const [searchParams] = useSearchParams(); // ✅ 변수명 수정
  const categoryId = searchParams.get("category_id") || "all"; // ✅ 기본값 추가

  return (
    <Container sx={{ pb:7, pt:7, pl:0, pr:0, display:"flex",flexDirection:"column"}}>
      {/* 🔹 헤더 영역 */}
      <HeaderBar title="장소 목록" showBack />
      <Box sx={{pl:2,pr:2, pt:2, flex:1}}>

        {/* 🔸 카테고리 목록 */}
        <PlacesCategoryList selectedCategoryId={categoryId} />
        
        {/* 🔸 장소 목록 */}
        <FindList categoryId={categoryId} />
      </Box>
      <FixedBottomNavigation sx={{flex:0}}></FixedBottomNavigation>
    </Container>
  );
};

export default Find;
